import queryString from 'query-string';

import request from 'utils/request';
import { getUserCurrentStore } from 'utils/auth';
import { pageSizeTypes } from 'utils/pagination';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

export function getReportsDiscountsRequest(
  { startDate, endDate, page, brands, providers, discountTypes, users, reportFormat, orderBy },
  options = {},
) {
  const storeUuid = getUserCurrentStore()?.uuid;

  const query = queryString.stringify({
    store_uuid: storeUuid,
    start_date: startDate,
    end_date: endDate,
    brand: brands,
    scope: discountTypes,
    user: users,
    provider: providers,
    report_format: reportFormat,
    page_size: pageSizeTypes.PAGE_SIZE_DEFAULT,
    page,
    order_by: orderBy,
  });

  return request(`${API_BASE_URL}/v1/reports/discounts/?${query}`, {
    method: 'GET',
    ...options,
  });
}

export function exportReportsDiscountsExcelRequest(
  { startDate, endDate, brands, providers, discountTypes, users, reportFormat },
  options = {},
) {
  const storeUuid = getUserCurrentStore()?.uuid;

  const query = queryString.stringify({
    store_uuid: storeUuid,
    start_date: startDate,
    end_date: endDate,
    brand: brands,
    scope: discountTypes,
    user: users,
    provider: providers,
    report_format: reportFormat,
  });

  return request(`${API_BASE_URL}/v1/reports/discounts/export/?${query}`, {
    method: 'GET',
    config: {
      responseType: 'blob',
    },
    ...options,
  });
}
